module.exports = __webpack_public_path__ + "static/img/1.a595a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/1.png
// module id = X5Za
// module chunks = 0